var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "500"
    },
    model: {
      value: _vm.show,
      callback: function callback($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "tit tit--xs"
  }, [_c('b', [_vm._v("상품정보 다운로드")])])]), _c('v-divider'), _c('v-card-text', [_c('v-radio-group', {
    attrs: {
      "label": "선택구분",
      "row": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.type,
      callback: function callback($$v) {
        _vm.type = $$v;
      },
      expression: "type"
    }
  }, [_c('v-radio', {
    staticClass: "ma-0 mx-2 ",
    attrs: {
      "label": "기본선택",
      "value": "basic"
    }
  }), _c('v-radio', {
    staticClass: "ma-0 mx-2 ",
    attrs: {
      "label": "전체선택",
      "value": "all"
    }
  })], 1)], 1), _c('v-divider'), _c('v-card-title', {
    staticClass: "pb-2"
  }, [_c('span', {
    staticClass: "tit tit--xs"
  }, [_vm._v("기본정보")])]), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "mr-2",
    attrs: {
      "label": "상품코드",
      "value": "code",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }), _c('v-checkbox', {
    staticClass: "mr-2",
    attrs: {
      "label": "상품명",
      "value": "name",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }), _c('v-checkbox', {
    staticClass: "mr-2",
    attrs: {
      "label": "카테고리",
      "value": "category",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }), _c('v-checkbox', {
    staticClass: "mr-2",
    attrs: {
      "label": "상품진열",
      "value": "onDisplay",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }), _c('v-checkbox', {
    staticClass: "mr-2",
    attrs: {
      "label": "품절여부",
      "value": "soldout",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }), _c('v-checkbox', {
    staticClass: "mr-2",
    attrs: {
      "label": "재고량",
      "value": "stock",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  })], 1)], 1), _c('v-divider'), _c('v-card-title', {
    staticClass: "pb-2"
  }, [_c('span', {
    staticClass: "tit tit--xs"
  }, [_vm._v("가격 및 옵션")])]), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "mr-2",
    attrs: {
      "label": "소비자가(정가)",
      "value": "costPrice",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }), _c('v-checkbox', {
    staticClass: "mr-2",
    attrs: {
      "label": "판매가",
      "value": "salePrice",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }), _c('v-checkbox', {
    staticClass: "mr-2",
    attrs: {
      "label": "적립 포인트",
      "value": "pointPercent",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }), _c('v-checkbox', {
    staticClass: "mr-2",
    attrs: {
      "label": "옵션",
      "value": "optionalProducts",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  })], 1)], 1), _c('v-divider'), _c('v-card-title', {
    staticClass: "pb-2"
  }, [_c('span', {
    staticClass: "tit tit--xs"
  }, [_vm._v("상품 사진 / 설명")])]), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "mr-2",
    attrs: {
      "label": "상품사진",
      "value": "images",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }), _c('v-checkbox', {
    staticClass: "mr-2",
    attrs: {
      "label": "작가",
      "value": "writer",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }), _c('v-checkbox', {
    staticClass: "mr-2",
    attrs: {
      "label": "출판사",
      "value": "publisher",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  })], 1)], 1), _c('v-divider'), _c('v-divider'), _c('v-card-title', {
    staticClass: "pb-2"
  }, [_c('span', {
    staticClass: "tit tit--xs"
  }, [_vm._v("공제 분류")])]), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "mr-2",
    attrs: {
      "label": "공제여부",
      "value": "isDeduction",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  })], 1)], 1), _c('v-divider'), _c('v-divider'), _c('v-card-title', {
    staticClass: "pb-2"
  }, [_c('span', {
    staticClass: "tit tit--xs"
  }, [_vm._v("배송정책")])]), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "mr-2",
    attrs: {
      "label": "배송정책",
      "value": "shippingCode",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  })], 1)], 1), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "grey"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("취소")]), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("확인")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }